import { IApplicationState } from 'shared/types/redux';

export const getCoworkingDescription = ({ coworking }: IApplicationState) => coworking?.description || '';
